'use client';

import {
	createListCollection,
	Spinner,
	Stack,
} from '@chakra-ui/react';
import React from 'react';

import type { DesiredJobLocationStep } from '@/modules/authentication';
import { useProvinceListQuery } from '@/modules/shared';

import { Form } from '@packages/hook-form-wrapper';

export const DesiredJobLocation = () => {
	const { data: provinces = [], isLoading } = useProvinceListQuery();

	if (isLoading) return <Spinner />;

	const collection = createListCollection({
		items: provinces.map(province => ({
			category: province.region,
			label:    (province.localized as Record<string, string>)?.en || '',
			value:    province.id,
		})),
	});

	return (
		<Stack gap="lg">
			<Form.SelectInputGroup<DesiredJobLocationStep>
				clearTrigger
				collection={collection as never}
				helperText="Up to 3 can be registered"
				label="Preferred Job Location"
				multiple
				name="preferredLocationIds"
				size="lg"
			/>
			<Form.Checkbox name="openToAnyLocations">Any Location is acceptable</Form.Checkbox>
		</Stack>
	);
};
